export default __webpack_public_path__ + "static/media/thisdaylive.d0bffd5e.png";